/**
 * @generated SignedSource<<7e077f456bbd696a06113e28668cec1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: "Article";
  readonly " $fragmentSpreads": FragmentRefs<"articleSeoArticle" | "articleShareWidgetArticle" | "contentShareWidgetContent" | "headerContentBookmarkArticle" | "headerContentCommentTrigger" | "helpersCheckIsStyleArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseCurrentArticlePrebidConfigArticle" | "hooksUseNotificationReadStatusArticle" | "hooksUsePageTargetingArticle" | "onboardingNewsletterSubscriptionArticle">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "25a1b4646d950aa796b439421155ee85";

export default node;
